export function getFilteredStaticGridRecords(dataSource) {
    if (!dataSource || typeof dataSource.data !== "function") {
        return [];
    }

    var data = dataSource.data();
    if (!data) {
        return [];
    }

    var records = typeof data.toJSON === "function"
        ? data.toJSON()
        : Array.prototype.slice.call(data);

    var kendoNs = typeof globalThis !== "undefined" ? globalThis.kendo : undefined;
    if (!kendoNs || !kendoNs.data || !kendoNs.data.Query) {
        return records;
    }

    var query = new kendoNs.data.Query(records);
    var filter = typeof dataSource.filter === "function" ? dataSource.filter() : null;
    var sort = typeof dataSource.sort === "function" ? dataSource.sort() : null;

    if (filter) {
        query = query.filter(filter);
    }
    if (sort) {
        query = query.sort(sort);
    }

    return query.toArray();
}
